import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useEffect, useState} from 'react';

import {LogEditForm} from '../../components/LogEditForm';
import {FlatsListComponent} from '../../components/flats/FlatsListComponent';
import {Topbar} from '../../components/Topbar';
import {DashboardState} from './DashboardState';
import {LogEditState} from '../log-edit/LogEditState';
import {mainState} from '../../AppMainState';
import {useParams} from 'react-router-dom';
import {Loader} from '../../components/Loader';

export const DashboardComponent: FC = observer(() => {
    const {projectId} = useParams();
    const [initialized, setInitialized] = useState<number>(0);

    useEffect(() => {
        if (!mainState.dashboardState) {
            mainState.dashboardState = new DashboardState();
        }
        if (projectId) {
            mainState.dashboardState.setProject(projectId);
        }
        setInitialized(parseInt(projectId ?? '0'));
    }, [projectId]);

    const state = mainState.dashboardState;
    const [logEditState] = useState(() => new LogEditState());

    const showCreateLogForm = (state?.projectId && state.dashboardData?.length === 0) ?? false;

    useEffect(() => {
        logEditState.initNew(projectId);
    }, [showCreateLogForm, projectId]);


    if (!state) {
        return <Loader loading={!!state} />;
    }


    return (
        <section id="project-dashboard">
            <Topbar
                logsIds={state.logsIds}
                chartItems={state.graphData}
                currentGraphTimeSpan={state.graphTimeSpan}
                changeGraphTimeSpanHandler={(v) => state.setGraphTimeSpan(v)} />
            <h1 className="font-bold font-roboto-bold mb-4 text-3xl">{state.projectName}</h1>
            <div className="grid grid-cols-1 xl:grid-cols-2 xxl:grid-cols-3 gap-8">
                {state.dashboardData &&
                    state.dashboardListStates.map((l) => (
                        <FlatsListComponent
                            key={l.log?.logId + 'dashboardlog'}
                            state={l}
                        />
                    ))}
                {showCreateLogForm &&
                    <LogEditForm state={logEditState} />}
            </div>
        </section>
    );
});
